// extracted by mini-css-extract-plugin
export default {"purchaseList":"styles_purchaseList__byVtx"};